import { z } from 'zod';

const uuidSchema = z.string().uuid();

export const retrieveDecimalDigitsFromUUID = (
  uuid: string,
  digitsToExtract: number,
): number | null => {
  if (digitsToExtract <= 0) {
    return null;
  }

  if (digitsToExtract > 32) {
    console.warn('digitsToExtract exceeds available hex digits in UUID.');
    return null;
  }

  const isValidUUID = uuidSchema.safeParse(uuid).success;

  if (!isValidUUID) {
    console.warn('Invalid UUID format. Cannot determine logging eligibility.');
    return null;
  }

  const lastChar = uuid.slice(-digitsToExtract);
  const numberInDecimal = parseInt(lastChar, 16);

  if (Number.isNaN(numberInDecimal)) {
    console.warn('Invalid UUID format. Cannot determine logging eligibility.');
    return null;
  }

  return numberInDecimal;
};
